// This value should always be equal to the animation duration (in ms) in the animation CSS class
export const ANIMATION_DURATION = 167;
